export const dashboardConstants = {
  REQUEST_CURRENT_COMPANY: 'REQUEST_CURRENT_COMPANY',
  REQUEST_CURRENT_COMPANY_FINISHED: 'REQUEST_CURRENT_COMPANY_FINISHED'
};